import React from "react";
import { Provider } from "react-redux";
import { Product } from "~/common/Store/models/ProductListing";
import NotificationCenter from "~/common/Notification/NotificationCenter";
import Store from "~/common/Store";
import RelatedProduct from "./RelatedProduct";

interface Props {
  relatedProducts: Product[];
}
export default function VideoRelatedProducts({ relatedProducts }: Props) {
  return (
    <Provider store={Store}>
      <NotificationCenter />
      <div id="subject" className="side-col">
        <p className="header-3">Products Related To This Video</p>
        <div className="ag-mini box">
          {relatedProducts.map((product) => (
            <RelatedProduct {...{ product }} />
          ))}
        </div>
      </div>
    </Provider>
  );
}
